import { ReactNode } from 'react';
import { cn } from '@anytag/shared-utils';
import { HelpIcon } from '../Icon';

interface NoDataTitleProps {
  title: string;
  help?: string;
  className?: string;
  children?: ReactNode;
}
export const NoDataTitle = ({ help, title, children, className }: NoDataTitleProps) => (
  <div className={cn('flex items-center text-lg text-primary', className)}>
    {title}
    {help ? <HelpIcon help={help} place="top" className="ml-1.5" /> : null}
    {children}
  </div>
);
